import React, { createContext, useState, useContext, useEffect } from 'react';

export const SettingsContext = createContext({
  settings: {
    welcome_text: 'Рад тебя видеть в своем медиа пространстве',
    welcome_emoji: '🌻',
    logoUrl: '/logo.svg'
  },
  loading: true, // Загрузка по умолчанию true
  refreshSettings: () => {}
});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    welcome_text: 'Рад тебя видеть в своем медиа пространстве',
    welcome_emoji: '🌻',
    logoUrl: '/logo.svg'
  });
  const [loading, setLoading] = useState(true); // Состояние загрузки

  const fetchSettings = async () => {
    setLoading(true); // Начинаем загрузку
    try {
      const response = await fetch('/api/settings/public');
      if (response.ok) {
        const publicSettings = await response.json();
        setSettings({
          welcome_text: publicSettings.welcome_text || 'Рад тебя видеть в своем медиа пространстве',
          welcome_emoji: publicSettings.welcome_emoji || '🌻',
          logoUrl: publicSettings.logoUrl || '/logo.svg',
          ...publicSettings
        });
        localStorage.setItem('settings', JSON.stringify({
          timestamp: Date.now(),
          data: {
            welcome_text: publicSettings.welcome_text || 'Рад тебя видеть в своем медиа пространстве',
            welcome_emoji: publicSettings.welcome_emoji || '🌻',
            logoUrl: publicSettings.logoUrl || '/logo.svg',
            ...publicSettings
          }
        }));
      }
    } catch (error) {
      console.error('Ошибка при загрузке публичных настроек:', error);
      const cachedSettings = localStorage.getItem('settings');
      if (cachedSettings) {
        try {
          const { data } = JSON.parse(cachedSettings);
          setSettings(data);
        } catch (e) {
          console.error('Ошибка парсинга кешированных настроек:', e);
        }
      }
    } finally {
      setLoading(false); // Завершаем загрузку
    }
  };

  useEffect(() => {
    const cachedSettings = localStorage.getItem('settings');
    if (cachedSettings) {
      try {
        const { timestamp, data } = JSON.parse(cachedSettings);
        const cacheAge = Date.now() - timestamp;
        if (cacheAge < 300000) { // 5 минут
          setSettings(data);
          setLoading(false); // Данные из кеша, загрузка завершена
          console.log('Загружены кешированные настройки');
          return; // Выходим, если кеш актуален
        }
      } catch (error) {
        console.error('Ошибка при загрузке кешированных настроек:', error);
      }
    }
    // Если кеша нет или он устарел, или была ошибка, загружаем с сервера
    fetchSettings();
  }, []); // Пустой массив зависимостей для выполнения только при монтировании

  const refreshSettings = () => {
    fetchSettings(); 
  };

  // Функция updateGiftSectionSetting удалена, так как управление перенесено в GiftManagement.js
  // Настройка gifts_section_active будет загружаться через fetchSettings как часть publicSettings.

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings должен использоваться внутри SettingsProvider');
  }
  return context;
};
